import { createFileRoute } from '@tanstack/react-router';
import { influencerStaticData } from '../influencer';

export const Route = createFileRoute('/_private-routes/influencer/add')({
  staticData: influencerStaticData
});
